<template>
<div class="ew-page">
  <navbar-dashboard name="Recargar saldo"></navbar-dashboard>

  <div class="ew-page__body">
    <div class="ew-recharge">
      <!-- Columna izquierda: monto -->
      <section class="ew-card ew-recharge__col">
        <h2 class="ew-card-title">Monto a abonar</h2>

        <form v-if="currentStep === 1" @submit.prevent="createPrepaid" class="ew-form">
          <div class="ew-amount-field">
            <span class="ew-amount-field__prefix">$</span>
            <input
              type="number"
              min="0.01"
              step="0.01"
              class="ew-amount-field__input"
              placeholder="0.00"
              v-model="amount"
              required
            >
            <span class="ew-amount-field__suffix">MXN</span>
          </div>
          <p class="ew-amount-preview">{{ formatMXN(amount) }} MXN</p>

          <div class="ew-quick-amounts">
            <button
              type="button"
              class="ew-chip"
              v-for="q in quickAmounts"
              :key="q"
              @click="amount = q"
            >{{ formatMXN(q) }}</button>
          </div>

          <button class="ew-btn-primary ew-recharge__submit" type="submit" :disabled="!amount || amount <= 0 || isSubmitting">{{ isSubmitting ? 'Procesando…' : 'Continuar' }}</button>
        </form>

        <div v-else class="ew-amount-locked">
          <p class="ew-amount-locked__value">{{ formatMXN(amount) }} <span>MXN</span></p>
          <p class="ew-amount-locked__hint">Este es el monto que se abonará a tu monedero.</p>
          <button type="button" class="ew-link-btn" @click="deletePrepaid">Cambiar monto</button>
        </div>
      </section>

      <!-- Columna derecha: método de pago -->
      <section class="ew-card ew-recharge__col">
        <h2 class="ew-card-title">Método de pago</h2>

        <div class="ew-empty" v-if="currentStep === 1">
          <ph-icon name="credit-card" />
          <p class="ew-empty__title">Ingresa un monto para continuar</p>
          <p class="ew-empty__text">En cuanto confirmes el monto podrás elegir cómo pagarlo.</p>
        </div>

        <div v-else>
          {{ addEventPixeleFacebook() }}

          <div class="ew-pay-options">
            <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'paypal' }">
              <input type="radio" name="rechargePaymentMethod" @change="getLinkPaypal" v-on:click="paymentMethod = 'paypal'">
              <img class="ew-pay-option__logo" src="@/assets/images/paypal.png" alt="">
              <span class="ew-pay-option__label">PayPal</span>
            </label>

            <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'paypal-plus' }">
              <input type="radio" name="rechargePaymentMethod" v-on:click="paymentMethod = 'paypal-plus'">
              <img class="ew-pay-option__logo ew-pay-option__logo--card" src="@/assets/images/card-paypal.png" alt="">
              <span class="ew-pay-option__label">Pago con tarjeta</span>
            </label>

            <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'oxxo' }">
              <input type="radio" name="rechargePaymentMethod" v-on:click="paymentMethod = 'oxxo'">
              <img class="ew-pay-option__logo" src="@/assets/images/oxxopay_brand.png" alt="">
              <span class="ew-pay-option__label">OXXO</span>
            </label>
          </div>

          <div class="ew-recharge__actions">
            <a
              :href="paypalLink"
              class="ew-btn-primary"
              v-if="paypalLink !== '' && paymentMethod === 'paypal'"
            >Pagar</a>

            <button
              type="button"
              id="miniBrowserInitiateCheckout"
              class="ew-btn-primary"
              @click="initIframePayPalPlus"
              v-if="paypalpluslink !== '' && paymentMethod === 'paypal-plus'"
            >Pagar con tarjeta</button>

            <button
              type="button"
              class="ew-btn-primary"
              v-if="paymentMethod === 'oxxo'"
              v-on:click="paymentOXXO"
              :disabled="payDisabled"
            >Pagar</button>
          </div>
          <div class="ew-field-error" v-if="paymentError">{{ paymentError }}</div>
        </div>
      </section>
    </div>
  </div>

  <div id="ppplusDiv"></div>
</div>
</template>

<script>
import axios from 'axios';
import commons from '../commons';
import api from "../commons/api";
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Navbar from './Header/Navbar';
import service from "../commons/api";
import { formatMXN } from '../commons/currency';
import PhIcon from './icons/PhIcon';
export default {
  name: 'NewPrepaid',
  data () {
    return {

      paypalplay:null,
      paypalpluslink:"",
      newShip: false,
      idUser: "",
      isLoging: false,
      isOpenDetail: [],
      paymentMethod: "",
      payDisabled: false,
      quotingLocked: true,
      paypalLink: "",
      payment_id:"",
      prepaidId: null,
      paymentError: '',
      isSubmitting: false,
      amount: 0,
      quickAmounts: [500, 1000, 2000, 5000],
      quotingLocked: true,
      user:{
        first_names:"",
        last_names:"",
        email:""
      },
      step: 1
    }
  },
  methods: {
  formatMXN,

  paymentOXXO() {
    if ("oxxo" === this.paymentMethod) {
      this.payDisabled = true;
      this.paymentError = '';
      axios
        .post(
          `${commons.apiURL}/api/v1/payments/conekta/oxxo/prepaid/${this.prepaidId}`,
          { email: this.user.email }
        )
        .then(response => {
          if (response.data.message === "ok") {
            this.payDisabled = false;
            this.$router.push({
              path: "/payments/result/success",
              query: {
                oxxo: "true",
                reference: response.data.reference,
                email: this.user.email
              }
            });
          } else {
            this.payDisabled = false;
            this.paymentError = 'No se pudo generar el pago en Oxxo. Intenta de nuevo.';
          }
        })
        .catch(() => {
          this.payDisabled = false;
          this.paymentError = 'No se pudo generar el pago en Oxxo. Intenta de nuevo.';
        });
    }
  },

    nextStep () {
      if (this.currentStep < 2) {
        this.step++
      }
    },
    prevStep () {
      if (this.currentStep > 1) {
        this.step--
      }
    },
    createPrepaid () {
      // Fase 3, punto 4 del plan de monedero: el botón solo se deshabilitaba
      // por !amount, no mientras la petición estaba en curso — un doble
      // click alcanzaba a crear dos recargas pendientes duplicadas.
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.newShip = true;
      const requestBody = {
        user: this.idUser,
        amount: this.amount
      }

      axios
        .post(`${commons.apiURL}/api/v1/prepaid`, requestBody)
        .then(response => {
          if(response.status == 200)
          {
            this.prepaidId = response.data.id;
            this.getLinkPaypal();
            this.getLinkPaypalPlus();
            this.nextStep();
          }
          this.isSubmitting = false;
        })
        .catch(error => {
          console.error(error);
          this.isSubmitting = false;
        });
    },
    deletePrepaid() {
      this.newShip = false;
      axios
        .delete(`${commons.apiURL}/api/v1/prepaid/${this.prepaidId}`)
        .then(response => {
          this.prevStep();
        })
        .catch(error => {
          console.error(error);
        });
    },
    getLinkPaypal(){
    console.log(`${commons.apiURL}/api/v1/prepaid/getLinkpaypal/${this.prepaidId}?email=${this.user.email}`)
      axios
        .post(
          `${commons.apiURL}/api/v1/prepaid/getLinkpaypal/${this.prepaidId}?email=${this.user.email}`
        )
        .then(response => {
          this.paypalLink = response.data.url;
          console.log(response.data)
        });
    },
    getLinkPaypalPlus(){
      service.prepaid.getPaypalLink(this.prepaidId).then((response)=>{
        let data = response.data.data;
        if (data) {
         this.paypalpluslink = data.link;
         this.payment_id = data.payment_id;
        }
      }).catch((error)=>{
        this.paypalpluslink = ""
      })
    },
    getStatusSesion() {
      if (localStorage.getItem("ew-user-id") !== null) {
        this.idUser = localStorage.getItem("ew-user-id");
        this.isLoging = true;
      } else {
        this.idUser = null;
        this.isLoging = false;
      }
    },



    ...mapMutations([
      'netNewPrepaidRequestBody',
      'setItemActive'
    ]),
    ...mapActions([]),



    scrollTo(coord){

      let element = document.getElementById('autocomplete-results-das');
      element.scrollTo(0,coord)
    },


    addEventPixeleFacebook() {
      fbq("track", "InitiateCheckout");
    },
    initIframePayPalPlus(){
      this.paypalplay = PAYPAL.apps.PPP({
        approvalUrl: this.paypalpluslink,
        placeholder: "ppplusDiv",
        mode: "live",
        payerEmail:`${this.user.email}`,
        payerFirstName: `${this.user.first_names}`,
        payerLastName: `${this.user.last_names}`,
        payerPhone: `${this.user.phone}`,
        payerTaxId: "",
        payerTaxIdType: "",
        country: "MX",
        language:"es_MX",
        miniBrowser:true,
        buttonLocation:"inside",
        disallowRememberedCards:true,
        onMiniBrowserClose:function () {
          console.log("close")
        },
        onContinue:(rememberedCards, payer_id, token) => {
          let email = this.user.email;
          // Fase 2 del plan de monedero: usaba api.shipment.executePayment
          // (pensado para pagar un envío) en vez de api.prepaid.executePayment
          // — pegaba a la ruta equivocada y la recarga nunca se acreditaba
          // aunque sí se cobrara al cliente.
          api.prepaid.executePayment(this.payment_id, payer_id, this.prepaidId, email).then((response)=>{
            let data = response.data.data;
            if (data.execute) {
                this.$router.push({path: `/payments/result/success?home=true&email=${email}`});
            }else{
                this.$router.push({path: "/payments/result/error"});
            }
          }).catch((error)=>{
              this.$router.push({path: "/payments/result/error"});
          })
        },
        onError: function (err) {
          this.$router.push({path: "/payments/result/error"});
        },
        onLoad:function(){
          console.log("carga realizada con exito")
        }
      });
    },
  },
  computed: {
    currentStep () {
      return this.step
    },
    ...mapGetters([

    ]),

  },
  created () {
    this.setItemActive('prepaids')
    this.getStatusSesion();
    if (localStorage.getItem('ew-user-id')) {
      axios
      .get(`${commons.apiURL}/api/v1/users/${localStorage.getItem('ew-user-id')}`)
      .then(response => {
        this.user.email = response.data.email
        this.user.first_names = response.data.firstName
        this.user.last_names = response.data.lastName
      }).catch(error => {
          console.trace(error)
      });
    }
  },
  mounted(){

  },
  destroyed(){

  },
  components: {
    'navbar-dashboard': Navbar,
    'ph-icon': PhIcon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-page { @include app-tokens; }
.ew-page__body { padding: 1.75rem 2rem 2.5rem; }

.ew-recharge {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: start;
  gap: 1.25rem;

  @media (max-width: 800px) { grid-template-columns: 1fr; }
}

.ew-card { @include ew-card; }
.ew-recharge__col { padding: 1.5rem 1.75rem; min-height: 22rem; }
.ew-card-title { @include ew-card-title; margin-bottom: 1.25rem; }

.ew-form { display: flex; flex-direction: column; gap: 1rem; max-width: none; /* App.vue trae un .ew-form global con max-width:400px legado de los formularios de auth viejos; sin este reset se hereda igual (misma especificidad, propiedades distintas) */ }

.ew-amount-field {
  display: flex;
  align-items: center;
  height: 3.25rem;
  padding: 0 1rem;
  border: 1px solid var(--app-border);
  border-radius: var(--app-radius-sm);
  background: #fff;
  gap: 0.5rem;

  &:focus-within { border-color: var(--app-accent); }

  &__prefix { font-family: var(--app-font); font-size: 1.15rem; font-weight: 700; color: var(--app-navy); }
  &__suffix { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-muted); }

  &__input {
    flex: 1 1 auto;
    min-width: 0;
    border: none;
    outline: none;
    font-family: var(--app-mono);
    font-size: 1.4rem;
    font-weight: 700;
    color: var(--app-navy);
    background: transparent;

    &::placeholder { color: var(--app-border); font-weight: 400; }
    // Ocultar las flechas nativas del input number: el spinner por defecto
    // no combina con el prefijo "$"/sufijo "MXN" del campo.
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
    -moz-appearance: textfield;
  }
}

.ew-amount-preview {
  margin: -0.5rem 0 0;
  font-family: var(--app-font);
  font-size: 0.8rem;
  color: var(--app-muted);
}

.ew-quick-amounts {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}
.ew-chip {
  height: 2.1rem;
  padding: 0 0.9rem;
  border-radius: 999px;
  border: 1px solid var(--app-border);
  background: #fff;
  font-family: var(--app-font);
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--app-navy);

  &:hover { background: var(--app-surface-muted); }
  &:focus-visible { outline: 3px solid var(--app-accent); outline-offset: 2px; }
}

.ew-btn-primary { @include ew-btn-primary; }
.ew-recharge__submit { width: 100%; height: 3rem; margin-top: 0.5rem; }

.ew-amount-locked {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 1.5rem;
  border-radius: var(--app-radius-md);
  background: var(--app-surface-muted);

  &__value {
    margin: 0;
    font-family: var(--app-mono);
    font-size: 1.75rem;
    font-weight: 700;
    color: var(--app-navy);

    span { font-family: var(--app-font); font-size: 0.85rem; font-weight: 700; color: var(--app-muted); }
  }
  &__hint { margin: 0; font-family: var(--app-font); font-size: 0.82rem; color: var(--app-muted); }
}

.ew-link-btn {
  border: none;
  background: none;
  padding: 0;
  margin-top: 0.25rem;
  font-family: var(--app-font);
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--app-accent-button);
  &:hover { text-decoration: underline; }
}

.ew-empty { @include ew-empty; }
.ew-empty__title { @include ew-empty-title; }
.ew-empty__text { @include ew-empty-text; }

.ew-pay-options {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.ew-pay-option {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  padding: 0.9rem 1rem;
  border: 1.5px solid var(--app-border);
  border-radius: var(--app-radius-md);
  cursor: pointer;
  transition: border-color .15s ease, background-color .15s ease;

  input { position: absolute; opacity: 0; width: 0; height: 0; }

  &:hover { background: var(--app-surface-muted); }

  &.is-selected {
    border-color: var(--app-accent);
    background: var(--app-surface-muted);
  }

  &__logo { height: 1.6rem; width: auto; }
  &__logo--card { height: 1.3rem; }

  &__label {
    font-family: var(--app-font);
    font-size: 0.9rem;
    font-weight: 700;
    color: var(--app-navy);
  }
}

.ew-recharge__actions {
  display: flex;
  justify-content: flex-end;

  .ew-btn-primary { width: 100%; height: 3rem; text-decoration: none; }
}
</style>



// WEBPACK FOOTER //
// src/components/NewPrepaid.vue